import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  settingsCardTitle: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.settingsCardTitle`,
    defaultMessage: 'Rehire Check Stage Settings',
  },
  connectorLabel: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.connectorLabel`,
    defaultMessage: 'HRIS connector',
  },
  connectorPlaceholder: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.connectorPlaceholder`,
    defaultMessage: 'Select a connector',
  },
  connectorAutoSelectedHelperText: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.connectorAutoSelectedHelperText`,
    defaultMessage: 'Auto-selected — one active HRIS connector',
  },
  zeroConnectorsNotice: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.zeroConnectorsNotice`,
    defaultMessage: 'Connect an HRIS in the Connector Marketplace first',
  },
  eligibilityFieldLabel: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.eligibilityFieldLabel`,
    defaultMessage: 'Eligibility field',
  },
  eligibilityFieldHelperText: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.eligibilityFieldHelperText`,
    defaultMessage: 'Select a field mapped on this connector',
  },
  eligibilityFieldAutoSelectedHelperText: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.eligibilityFieldAutoSelectedHelperText`,
    defaultMessage: 'Auto-selected — one eligibility field on this connector',
    description: 'Helper text when a connector exposes one eligibility field',
  },
  legacyEligibilityFieldHelperText: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.legacyEligibilityFieldHelperText`,
    defaultMessage:
      'This saved field is not mapped on this connector. Choose a mapped field before testing this stage.',
    description:
      'Warning for an eligibility field missing from connector metadata',
  },
  noEligibilityFieldsNotice: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.noEligibilityFieldsNotice`,
    defaultMessage:
      'No rehire eligibility field is mapped for this connector. Contact Fountain support.',
    description:
      'Blocked state when connector metadata has no eligibility fields',
  },
  eligibleValuesLabel: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.eligibleValuesLabel`,
    defaultMessage: 'Values that mean eligible',
  },
  eligibleValuesHelperText: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.eligibleValuesHelperText`,
    defaultMessage: 'Anything else — including blank — is not eligible',
  },
  eligibleValuesPlaceholder: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.eligibleValuesPlaceholder`,
    defaultMessage: 'Type a value and press enter',
  },
  terminatedEmployeesLabel: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.terminatedEmployeesLabel`,
    defaultMessage: 'terminated employees',
    description: 'Label after the count for an observed eligibility value',
  },
  valuesStillSyncingHelperText: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.valuesStillSyncingHelperText`,
    defaultMessage:
      'Still reading your worker data. This usually takes a few minutes after a new connection — reopen this stage shortly.',
    description: 'Helper text while the connector initial sync is incomplete',
  },
  emptyObservedValuesHelperText: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.emptyObservedValuesHelperText`,
    defaultMessage:
      'Checked {sampleSize} former workers and this field is empty on all of them. Populate it in your HRIS before this check can return useful results.',
    description:
      'Helper text when sampled former workers have no eligibility value',
  },
  onUnavailableLabel: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.onUnavailableLabel`,
    defaultMessage: 'If the check cannot complete',
  },
  onUnavailableHold: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.onUnavailableHold`,
    defaultMessage: 'Keep applicant on this stage (recommended)',
  },
  onUnavailableContinue: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.onUnavailableContinue`,
    defaultMessage: 'Continue to the rules below',
  },
  shadowModeLabel: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.shadowModeLabel`,
    defaultMessage: "Shadow mode — log the verdict only, don't hold or route",
  },
  shadowModeHelperText: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.shadowModeHelperText`,
    defaultMessage:
      'For testing — verdicts are recorded but never hold or route the applicant',
  },
  enrichmentTitle: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.enrichmentTitle`,
    defaultMessage: 'Data from the matched record',
    description:
      'Title for configuring applicant fields copied from an HRIS match',
  },
  enrichmentDescription: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.enrichmentDescription`,
    defaultMessage: 'up to five, on top of the above',
    description:
      'Instructions for configuring fields copied from an HRIS match',
  },
  enrichmentSuggestionsLabel: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.enrichmentSuggestionsLabel`,
    defaultMessage: 'Also copy, if you want',
    description: 'Label for suggested HRIS fields that can be copied',
  },
  alwaysCopiedTitle: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.alwaysCopiedTitle`,
    defaultMessage: 'Always copied',
    description:
      'Title for applicant context fields copied automatically from an HRIS match',
  },
  alwaysCopiedEmploymentStatusDescription: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.alwaysCopiedEmploymentStatusDescription`,
    defaultMessage: 'Whether they still work for you',
    description: 'Meaning of the automatically copied employment status field',
  },
  alwaysCopiedTerminationDateDescription: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.alwaysCopiedTerminationDateDescription`,
    defaultMessage: 'When they left',
    description:
      'Meaning of the automatically copied employment termination date field',
  },
  alwaysCopiedOriginalHireDateDescription: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.alwaysCopiedOriginalHireDateDescription`,
    defaultMessage: 'When they started',
    description: 'Meaning of the automatically copied original hire date field',
  },
  alwaysCopiedMatchedIdDescription: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.alwaysCopiedMatchedIdDescription`,
    defaultMessage: 'Their ID in your HRIS, this stage only',
    description:
      'Meaning of the stage-scoped matched HRIS record identifier, which is not the canonical worker HRIS identifier',
  },
  enrichmentSourceLabel: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.enrichmentSourceLabel`,
    defaultMessage: 'HRIS field',
    description: 'Column label for a source field from the HRIS',
  },
  enrichmentTargetLabel: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.enrichmentTargetLabel`,
    defaultMessage: 'Fountain data key',
    description:
      'Column label for the applicant data key that receives a copied value',
  },
  enrichmentRemoveMapping: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.enrichmentRemoveMapping`,
    defaultMessage: 'Remove {field} mapping',
    description: 'Accessible label for removing one HRIS field mapping',
  },
  enrichmentLimitReached: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.enrichmentLimitReached`,
    defaultMessage: 'You can add up to five field mappings',
    description: 'Reason that no more HRIS field mappings can be added',
  },
  enrichmentCopyNotice: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.enrichmentCopyNotice`,
    defaultMessage:
      'Written once, at the moment of the match, overwriting what is already on the applicant. Not kept in sync with your HRIS afterwards.',
    description:
      'Explains when HRIS values are copied and that they can replace applicant data',
  },
  enrichmentTargetRequired: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.enrichmentTargetRequired`,
    defaultMessage: 'Enter a Fountain data key',
    description:
      'Guidance when a copied HRIS field has no destination data key',
  },
  enrichmentTargetHrisIdReserved: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.enrichmentTargetHrisIdReserved`,
    defaultMessage: 'hris_id is reserved. Enter another data key.',
    description:
      'Guidance when the HRIS identifier is selected as a copy destination',
  },
  enrichmentTargetPrefixReserved: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.enrichmentTargetPrefixReserved`,
    defaultMessage:
      'Data keys cannot start with rehire_check_. Enter another data key.',
    description:
      'Guidance when a system-owned rehire data key is selected as a copy destination',
  },
  enrichmentTargetDuplicate: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.enrichmentTargetDuplicate`,
    defaultMessage: 'Each mapping needs a different Fountain data key',
    description:
      'Guidance when two HRIS fields use the same destination data key',
  },
  enrichmentSourceManager: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.enrichmentSourceManager`,
    defaultMessage: 'Supervisor',
    description: 'Display name for a former supervisor from the HRIS',
  },
  enrichmentSourceWorkLocation: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.enrichmentSourceWorkLocation`,
    defaultMessage: 'Previous location',
    description: 'Display name for a previous work location from the HRIS',
  },
  enrichmentSourceEmploymentType: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.enrichmentSourceEmploymentType`,
    defaultMessage: 'Employment type',
    description: 'Display name for a previous employment type from the HRIS',
  },
  dryRunCardTitle: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.dryRunCardTitle`,
    defaultMessage: 'Test this configuration',
  },
  dryRunDescription: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.dryRunDescription`,
    defaultMessage:
      'Runs the current settings against your HRIS without creating an applicant',
  },
  dryRunEmailLabel: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.dryRunEmailLabel`,
    defaultMessage: 'Email',
  },
  dryRunSsnLabel: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.dryRunSsnLabel`,
    defaultMessage: 'SSN last 4 (optional)',
  },
  dryRunButton: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.dryRunButton`,
    defaultMessage: 'Run test',
  },
  dryRunResultRawValueLabel: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.dryRunResultRawValueLabel`,
    defaultMessage: 'Raw field value',
  },
  dryRunResultStatusLabel: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.dryRunResultStatusLabel`,
    defaultMessage: 'Employment status',
  },
  dryRunResultTerminationDateLabel: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.dryRunResultTerminationDateLabel`,
    defaultMessage: 'Termination date',
  },
  dryRunResultDataAsOfLabel: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.dryRunResultDataAsOfLabel`,
    defaultMessage: 'Data as of',
  },
  dryRunErrorMessage: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.dryRunErrorMessage`,
    defaultMessage:
      "We couldn't reach the test tool. Check your connection and try again.",
  },
  verdictEligible: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.verdictEligible`,
    defaultMessage: 'Eligible',
  },
  verdictNotEligible: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.verdictNotEligible`,
    defaultMessage: 'Not eligible',
  },
  verdictNoMatch: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.verdictNoMatch`,
    defaultMessage: 'No match',
  },
  verdictAmbiguous: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.verdictAmbiguous`,
    defaultMessage: 'Ambiguous match',
  },
  verdictUnavailable: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.verdictUnavailable`,
    defaultMessage: "Can't verify",
  },
  verdictFieldNotMapped: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.verdictFieldNotMapped`,
    defaultMessage: 'Field not mapped',
  },
  verdictFieldNotMappedExplanation: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.verdictFieldNotMappedExplanation`,
    defaultMessage:
      'The eligibility field is not mapped on this connector. Choose a mapped field and try again.',
    description:
      'Guidance when the selected HRIS field is unavailable on the connector',
  },
  verdictUnavailableNoConnector: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.verdictUnavailableNoConnector`,
    defaultMessage:
      'The check could not run because no active HRIS connector is available. Connect one and try again.',
    description: 'Guidance when no active HRIS connector is available',
  },
  verdictUnavailableLookupError: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.verdictUnavailableLookupError`,
    defaultMessage: 'The check could not run. Try again.',
    description: 'Guidance when an HRIS lookup does not complete',
  },
  ruleOrderingHint: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.ruleOrderingHint`,
    defaultMessage:
      'Rules evaluate top-down. Place currently employed above the verdict statuses because a current employee can match more than one status.',
  },
});
